export class saleOrderNoRequest{
    saleOrderId : number;
    unitId?:number
}